import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';
import { PropsWithChildren } from 'react';

import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

import { brtBunja } from '../state';

export const TopBar = () => {
  const { collapseDepthAtom, reloadBrt, expandAll, collapse } = useBunja(brtBunja);
  const [collapseDepth, setCollapseDepth] = useAtom(collapseDepthAtom);
  return (
    <div
      className={flex({
        h: 28,
        gap: 2,
        borderBottom: '1px solid',
        borderBottomColor: 'border.default.level-1',
        bgColor: 'background.default.level-1',
        alignItems: 'center',
      })}
    >
      <Button onClick={reloadBrt}>🔄 Reload</Button>
      <Button onClick={expandAll}>📂 Expand All</Button>
      <Button onClick={collapse}>
        <span>📁 Collapse</span>
        <input
          type='number'
          min={1}
          value={collapseDepth}
          onChange={(e) => {
            e.stopPropagation();
            setCollapseDepth(Number(e.target.value));
          }}
          onClick={(e) => e.stopPropagation()}
          className={css({
            w: 28,
            px: 4,
            py: 0,
            border: '1px solid',
            borderColor: 'border.default.level-2',
            rounded: 2,
            fontSize: '11px',
            color: 'content.default.level-5',
            bgColor: 'background.default.level-0',
            textAlign: 'center',
            h: 18,
            _focus: {
              outline: 'none',
              borderColor: 'border.accent.info',
            },
          })}
        />
      </Button>
    </div>
  );
};

interface ButtonProps extends PropsWithChildren {
  onClick: () => void;
}
const Button = ({ children, onClick }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={css({
        cursor: 'pointer',
        border: 'none',
        bgColor: 'transparent',
        px: 6,
        py: 2,
        rounded: 3,
        fontSize: '11px',
        color: 'content.default.level-4',
        transition: 'all 0.15s ease',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        _hover: {
          bgColor: 'background.default.level-2',
          color: 'content.default.level-5',
        },
      })}
    >
      {children}
    </button>
  );
};
